import * as z from "zod/v4";

export const getEstimatedAnnualRevenue = {
  name: "getEstimatedAnnualRevenue" as const,
  input: z.object({}),
  output: z.object({
    annualRevenue: z.number().nullable(),
    dataAvailable: z.boolean(),
    reason: z.enum(["no_data", "invalid_data"]).optional(),
  }),
};
